import ManagerAppContainer from "./ManagerAppContainer";

export default ManagerAppContainer;
